import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useNavigate } from 'react-router-dom';
import { getCreateUrlFromPipeline } from '@/utils/constants';
import { usePipelineContext } from '@/context/pipelineContext';

export const AddNewDealButton = ({ pipeline = process.env.REACT_APP_PIPELINE_NEW_BUSINESS }) => {
	const { clientRow } = useObjectContext();

	const { pipeline: pipelineObj } = usePipelineContext(pipeline);

	const navigate = useNavigate();

	const handleNavigate = () => {
		const path = getCreateUrlFromPipeline(pipeline);
		navigate(path, { state: { client: clientRow, clientId: clientRow?.clientId } });
	};

	const label = useMemo(() => {
		const label = pipelineObj?.label ?? '';
		if (pipeline === process.env.REACT_APP_PIPELINE_NEW_BUSINESS) return label;
		return label.slice(0, -1);
	}, [pipeline, pipelineObj?.label]);

	return (
		<Button
			variant='tab_header'
			style={{ textWrap: 'nowrap' }}
			startIcon={<Add />}
			onClick={handleNavigate}
		>
			{`Create ${label}`}
		</Button>
	);
};
